var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',_vm._l((_vm.tabList),function(tab){
var _obj;
return _c('li',{key:tab.text,staticClass:"tabs-item",class:( _obj = {selected:tab.type===_vm.value}, _obj[_vm.classPrefix+'-item'] = _vm.classPrefix, _obj ),on:{"click":function($event){return _vm.selectType(tab.type)}}},[_vm._v(_vm._s(tab.text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }